export default class ReportQ {
  constructor(callback) {
    this.q = [];
    this.timer = null;
    this.listener = callback;
    this.ended = false;

    this.timerTask = () => {
      //console.log("run: Timer..")
      try {
        // const d = this.q[0]
        //console.log("run: Report..")
        this.q.shift();
      } catch (e) {
        if (this.ended) {
          this.listener.onEmpty();
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    };

    this.timer = setInterval(this.timerTask, 1000);
  }

  sendReport() {}

  add(message) {
    this.q.push(new Data(message));
  }

  end() {
    this.ended = true;
  }
}

class Data {
  constructor(msg) {
    this.time = Date.now();
    this.message = msg;
  }
}
